/**
 * @packageDocumentation
 * Builds the info button control and its popup, giving players access to help and game details at runtime.
 */
import * as PIXI from "pixi.js";
import { Assets } from "pixi.js";
import { brightnessFilter, font_main } from "./global";
import { SoundManager } from "./sounds";
import addInteraction from "../lib/addButtonInteraction";

/**
 * Class representing the Info area UI component
 * @extends PIXI.Container
 */
export class InfoButton extends PIXI.Container {
  private InfoContainer: PIXI.Container;
  private InfoValueText: PIXI.Text;
  // private PopupContainer: PIXI.Container | null = null;

  constructor() {
    super();

    // Main container for the button
    this.InfoContainer = new PIXI.Container();

    // Info Button Background
    const InfoBg: PIXI.Sprite = new PIXI.Sprite(Assets.get("How_to_play_but"));
    InfoBg.anchor.set(0.5);
    InfoBg.scale.set(0.75);

    // Info Button Text
    this.InfoValueText = new PIXI.Text();
    this.InfoValueText.text = "HOW TO PLAY";
    this.InfoValueText.style = {
      fontFamily: font_main,
      align: "center",
      fill: "white",
      fontSize: 23,
      fontWeight: "lighter",
      dropShadow: {
        alpha: 0.8,
        angle: 1,
        blur: 4,
        color: "0x111111",
        distance: 2,
      },
      stroke: {
        color: "black",
        width: 2,
        join: "round",
      },
      // letterSpacing: 2,
    } as PIXI.TextStyle;

    this.InfoValueText.anchor.set(0.5);
    this.InfoValueText.x = 30;
    this.InfoValueText.y = 2;

    this.InfoContainer.addChild(InfoBg, this.InfoValueText);

    const onHandleTapFunc = () => {
      SoundManager.Btnclick_1SndPlay();
      document.getElementById('info-page')!.style.display = 'block';
    };
    addInteraction(this.InfoContainer, onHandleTapFunc, false);
    
    this.addChild(this.InfoContainer);
  }
}
